export const VitalData = {
  VitalData: {
    ButtonTitleItemEdit: '項目を追加・編集する',
    Fitbit: 'Fitbit',
    Hours: '時間',
    Minutes: '分',
    Notes: '※睡眠スコアではありません',
  },
  VitalDataInput: {
    ButtonTitleSave: '登録',
    Date: '日',
    Time: '時間',
    TimeSelect: '時間帯',
    BloodGlucoseLevel: '血糖値',
    BloodPressureHight: '最高血圧',
    BloodPressureLow: '最低血圧',
  },
  VitalItemEdit: {
    AboutFitbit: 'Fitbitとは',
    ButtonTitleCustomItemAdd: 'カスタム項目を追加する。',
    ButtonTitleSave: '保存',
  },
  CustomlItemEditModal: {
    SubTitleAdd: 'カスタム項目追加',
    SubTitleMod: 'カスタム項目変更',
    labelItemname: '項目名',
    labelUnit: '単位',
    ButtonAdd: '追加',
    ButtonModify: '変更',
    ButtonDelete: '削除する',
  },
  CustomItemLimitExceedModal: {
    limitExceed: 'カスタム項目は40個まで登録できます。',
    isOK: 'OK',
  },

  // 画面タイトル
  Title: {
    BSC_MN_530_001: '健康データ',
    BSC_MN_530_009: '項目の編集',
    BSC_MN_530_011: 'デイリーデータ入力',
  },
  Validation: {
    InvalidBloodPressureValue: '最高血圧よりも低い数値を入力してください',
  },
  ConfirmationDialog: {
    Text: 'カスタム項目の追加・変更が反映されませんが、\n宜しいでしょうか？',
    OK: 'OK',
    Cancel: 'キャンセル',
  },
  WarningDialog: {
    Text: '登録データも削除されますが、\n本当に削除しますか？',
    Delete: '削除する',
    Cancel: 'キャンセル',
  },
  CompleteDialog: {
    Text: 'デイリーデータを登録しました。',
  },

  DisplayRange: {
    Weekly: '週',
    Monthly: '月',
    Yearly: '年',
  },
  DateFormat: {
    YYYY_M_D: 'YYYY年M月D日',
    YYYY_M: 'YYYY年M月',
    YYYY: 'YYYY年',
    M_D: 'M月D日',
  },
  NoData: '-',
  DataList: 'データ一覧',
  DataInput: '入力',
  DataType: {
    Type_1: {
      Latest: '今日の{itemName}',
      Average: '平均{itemName}',
    },
    Type_3: {
      Latest: '今日',
      BeforeBreakfast: '朝食前',
      AfterBreakfast: '朝食後',
      BeforeLunch: '昼食前',
      AfterLunch: '昼食後',
      BeforeDinner: '夕食前',
      AfterDinner: '夕食後',
      Before: '食前',
      After: '食後',
    },
    Type_5: {
      AddTitle: '(Fitbit)',
    },
  },
  RawDataDeleteConfirm: {
    default: '{date} のデータを削除しますか？',
    Type_3: '{date} {timeSlot} のデータを削除しますか？',
  },
};
